import React from "react";

import CDLImg from '../../images/services/CDL.png';
import ServiceTemplate from "./ServiceTemplate";

const SubItem = [];

const CDLLawyers = (props) => {
  return <ServiceTemplate 
  title="CDL Lawyers" 
  description={`TicketTamer is your CDL specialist and will work hard to keep you on the road – and you can do it all on your phone.

Federal rules prohibit prosecutors from “masking” CDL tickets. But TicketTamer knows how to deal with that rule. We know that rule better than most prosecutors, and if they won’t give you an acceptable offer, we will take your case to a jury trial for a reasonable fee if that’s what you want.

In our experience, most traffic lawyers are not willing to do this, so be sure to ask while you are looking for a lawyer. TicketTamer is ready for trial!

We offer translation services for more than 250 languages.`}
  subItem={SubItem}
  image={CDLImg}
  url="submit-speeding-ticket"
  metaDescription="Submit your CDL ticket - Get your quote instantly - Schedule your free consultation"
  />;
}

export default CDLLawyers;
